export const CONTACTS = {
  phone: "+370 677 73413",
  email: "mbartceiling@gmail.com",
  city: "Vilnius, Lietuva",
  hours: "I–V 8:00–18:00, VI 9:00–14:00",
};

export const HERO_IMAGE = {
  url: "/hero.jpg",
  alt: "Koridoriaus įtempiamos lubos su zigzago LED linijomis — ART Ceiling darbas",
};

export const STRENGTHS = [
  {
    id: "greitis",
    badge: "1 diena",
    title: "Montavimas per 1 dieną",
    description:
      "Profesionali meistrų komanda visą darbą atlieka greitai — ryte atvažiuojame, vakare paliekame tobulas lubas.",
  },
  {
    id: "garantija",
    badge: "10 metų",
    title: "10 metų garantija",
    description:
      "Suteikiame ilgalaikę garantiją tiek medžiagoms, tiek montavimo darbams. Ramybė dešimtmečiui.",
  },
  {
    id: "svara",
    badge: "100% švara",
    title: "Švarus darbas be dulkių",
    description:
      "Naudojame šiuolaikinę siurbimo įrangą — jokių statybinių dulkių, dažų dėmių ar sugadintos apdailos.",
  },
  {
    id: "sauga",
    badge: "Sertifikuota",
    title: "Saugi technologija",
    description:
      "Sertifikuotos nedegios medžiagos ir saugi įranga montavimo metu. Tinka net vaikų kambariams.",
  },
];

export const SERVICES = [
  {
    id: "matines",
    title: "Matinės lubos",
    subtitle: "Klasikinė elegancija ir nepriekaištingai lygus paviršius",
    description:
      "Klasikinis, tradicinio tinkuoto ir dažyto paviršiaus vaizdas. Neatsispindi šviesa, sukuriamas jaukumas ir ramybė bet kurioje patalpoje.",
    image_url: "/gallery/matines.jpg",
    features: [
      "100% lygus paviršius",
      "Neatspindi šviesos",
      "Idealu miegamiesiems ir svetainėms",
      "Greitas montavimas",
    ],
  },
  {
    id: "blizgios",
    title: "Blizgios lubos",
    subtitle: "Vizualiai padidina erdvę ir suteikia veidrodinio efekto",
    description:
      "Dėl aukšto atspindžio koeficienta patalpos vizualiai atrodo žymiai aukštesnės ir erdvesnės. Suteikia erdvei dinamikos ir modernumo.",
    image_url:
      "https://images.pexels.com/photos/8135492/pexels-photo-8135492.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    features: [
      "Veidrodinis atspindys",
      "Vizualiai aukština patalpą",
      "Atsparios drėgmei",
      "Lengva priežiūra",
    ],
  },
  {
    id: "led-linijos",
    title: "LED linijos",
    subtitle: "Inovatyvus architektūrinis apšvietimas integruotas į lubas",
    description:
      "Moderniausia tendencija — į lubas įleistos šviečiančios linijos, galinčios tarnauti kaip pagrindinis arba akcentinis apšvietimas.",
    image_url: "/gallery/led-linija.jpg",
    features: [
      "Integruotas LED profilis",
      "Dimeriuojamas apšvietimas",
      "Minimalistinis dizainas",
      "Taupanti energiją technologija",
    ],
  },
  {
    id: "medziagines",
    title: "Medžiaginės lubos",
    subtitle: "Besiūlis montavimas be kaitinimo su garso izoliacija",
    description:
      "Premium klasės tekstilinės lubos montuojamos be kaitinimo. Ypač tvirtos, pralaidžios orui, pasižyminčios akustinėmis savybėmis.",
    image_url:
      "https://images.unsplash.com/photo-1775644840774-453b26ecc45c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDB8MHwxfHNlYXJjaHw0fHxtaW5pbWFsaXN0JTIwaW50ZXJpb3IlMjBhcmNoaXRlY3R1cmFsJTIwY2VpbGluZyUyMGxpZ2h0fGVufDB8fHx8MTc5MjE4MzQ0MXww&ixlib=rb-4.1.0&q=85",
    features: [
      "Montavimas be dujų (šaltasis)",
      "Besiūlės iki 5 m pločio",
      "Padidinta garso izoliacija",
      "Ypač atsparios temperatūrai",
    ],
  },
];

export const LIGHTING = [
  {
    id: "led-linijos",
    title: "LED linijos",
    description: "Šviečiančios linijos, integruotos tiesiai į lubų paviršių — gali būti pagrindinis arba akcentinis apšvietimas.",
  },
  {
    id: "taskiniai",
    title: "Įleidžiami šviestuvai",
    description: "Diskretiški taškiniai šviestuvai tolygiam apšvietimui — parinksime skaičių ir išdėstymą pagal patalpos paskirtį.",
  },
  {
    id: "konturinis",
    title: "Paslėptas kontūrinis apšvietimas",
    description: "LED juostos nišose ir tarp lubų lygių — švelni šviesa, kuri vizualiai „pakelia“ lubas.",
  },
  {
    id: "sietynai",
    title: "Sietynai ir pakabinami šviestuvai",
    description: "Tvirtinimas ir pajungimas bet kurioje lubų vietoje — su sustiprinta platforma ir tvarkinga instaliacija.",
  },
  {
    id: "profiiliai",
    title: "Šviesos profilių sistemos",
    description: "Magnetiniai ir linijiniai profilių sprendimai, leidžiantys keisti šviestuvų padėtis bet kada.",
  },
  {
    id: "valdymas",
    title: "Dimeriavimas ir valdymas",
    description: "Apšvietimo intensyvumo reguliavimas, scenos ir valdymas telefonu arba nuotolinio valdymo pultu.",
  },
];

export const EXTRA_SERVICES = [
  {
    id: "demontavimas",
    title: "Lubų demontavimas",
    description:
      "Senų įtempiamų lubų ar kitų lubų konstrukcijų saugus išardymas ir lubų montavimas be pakeitimo. Darbas atliekamas švariai, be žalos sienoms.",
  },
  {
    id: "sviestuvai",
    title: "Šviestuvų montavimas",
    description:
      "Įleidžiamų šviestuvų, sietynų ir LED profilių montavimas. Parinksime apšvietimo sprendimą pagal jūsų interjerą ir sumontuosime per tą patį vizitą.",
  },
  {
    id: "kiti-darbai",
    title: "Kiti darbai",
    description:
      "Lubų remontas po pratekėjimo, garso izoliacija, nestandartinės formos ir kiti papildomi darbai. Kreipkitės — pasiūlysime individualų sprendimą.",
  },
];

export const GALLERY = [
  {
    id: 1,
    category: "led-linijos",
    title: "Paslėpta LED linija ir taškinis apšvietimas",
    location: "Privatus namas",
    image_url: "/gallery/led-linija.jpg",
  },
  {
    id: 2,
    category: "matines",
    title: "Matinės lubos su įleidžiamais šviestuvais",
    location: "Privatus namas",
    image_url: "/gallery/matines.jpg",
  },
  {
    id: 3,
    category: "procesas",
    title: "Prieš montavimą — perdanga, ventiliacija ir elektros išvedžiojimas",
    location: "Privatus namas",
    image_url: "/gallery/procesas-2.jpg",
  },
  {
    id: 4,
    category: "procesas",
    title: "Prieš montavimą — šviestuvų platformų ruošimas",
    location: "Privatus namas",
    image_url: "/gallery/procesas-1.jpg",
  },
  {
    id: 6,
    category: "led-linijos",
    title: "Erdvi svetainė su LED niša ir taškiniais šviestuvais",
    location: "Privatus namas",
    image_url: "/gallery/led-svetaine.jpg",
  },
  {
    id: 7,
    category: "led-linijos",
    title: "Paslėptas LED apšvietimas koridoriuje",
    location: "Privatus namas",
    image_url: "/gallery/led-koridoris.jpg",
  },
  {
    id: 8,
    category: "led-linijos",
    title: "Šviečianti LED niša prie užuolaidų",
    location: "Privatus namas",
    image_url: "/gallery/led-nisa.jpg",
  },
  {
    id: 9,
    category: "matines",
    title: "Matinės lubos su taškiniu apšvietimu ir sietynu",
    location: "Privatus namas",
    image_url: "/gallery/matines-taskai.jpg",
  },
  {
    id: 10,
    category: "matines",
    title: "Matinės lubos — detalė prie sienos",
    location: "Privatus namas",
    image_url: "/gallery/matines-detale.jpg",
  },
  {
    id: 11,
    category: "led-linijos",
    title: "LED linijos su kontūriniu apšvietimu",
    location: "Butas",
    image_url: "/gallery/led-linijos-2.jpg",
  },
  {
    id: 12,
    category: "led-linijos",
    title: "Dvigubos LED linijos su perimetriniu apšvietimu",
    location: "Butas",
    image_url: "/gallery/led-dvigubos.jpg",
  },
  {
    id: 13,
    category: "led-linijos",
    title: "LED linija virtuvės zonoje su taškiniais šviestuvais",
    location: "Butas",
    image_url: "/gallery/led-virtuve.jpg",
  },
  {
    id: 14,
    category: "led-linijos",
    title: "Kontūrinis LED apšvietimas visame perimetre",
    location: "Butas",
    image_url: "/gallery/led-perimetras.jpg",
  },
  {
    id: 15,
    category: "led-linijos",
    title: "Svetainė su kontūriniu LED apšvietimu per visą perimetrą",
    location: "Privatus namas",
    image_url: "/gallery/led-svetaine-didele.jpg",
  },
  {
    id: 16,
    category: "blizgios",
    title: "Blizgios veidrodinės lubos su juodu LED profiliu",
    location: "Privatus namas",
    image_url: "/gallery/blizgios-veidrodines.jpg",
  },
  {
    id: 17,
    category: "led-linijos",
    title: "Geometrinės šiltos šviesos LED linijos",
    location: "Butas",
    image_url: "/gallery/led-siltos.jpg",
  },
  {
    id: 18,
    category: "led-linijos",
    title: "Zigzago formos LED linijos šaltu šviesos tonu",
    location: "Butas",
    image_url: "/gallery/led-saltos.jpg",
  },
  {
    id: 19,
    category: "matines",
    title: "Matinės lubos mansardoje su šviestuvų išvedžiojimais",
    location: "Privatus namas",
    image_url: "/gallery/matines-mansarda.jpg",
  },
  {
    id: 20,
    category: "procesas",
    title: "Taškinių šviestuvų išvedžiojimas baigtose lubose",
    location: "Privatus namas",
    image_url: "/gallery/procesas-sviestuvai.jpg",
  },
  {
    id: 21,
    category: "procesas",
    title: "LED kontūro montavimas ir sietynų pajungimas",
    location: "Butas",
    image_url: "/gallery/procesas-led.jpg",
  },
  {
    id: 22,
    category: "led-linijos",
    title: "LED linija ir taškiniai šviestuvai vonioje",
    location: "Butas",
    image_url: "/gallery/led-vonia.jpg",
  },
  {
    id: 23,
    category: "led-linijos",
    title: "LED kontūras miegamajame",
    location: "Butas",
    image_url: "/gallery/led-miegamasis.jpg",
  },
  {
    id: 24,
    category: "led-linijos",
    title: "Trikampio formos LED linija prie langų",
    location: "Butas",
    image_url: "/gallery/led-trikampis.jpg",
  },
  {
    id: 25,
    category: "led-linijos",
    title: "Zigzago LED linijos virš durų zonos",
    location: "Butas",
    image_url: "/gallery/led-zigzagas.jpg",
  },
  {
    id: 26,
    category: "led-linijos",
    title: "LED linija koridoriaus lubose",
    location: "Butas",
    image_url: "/gallery/led-koridorius-2.jpg",
  },
  {
    id: 27,
    category: "led-linijos",
    title: "Šiltas kontūrinis LED apšvietimas vonioje",
    location: "Privatus namas",
    image_url: "/gallery/led-vonia-2.jpg",
  },
  {
    id: 28,
    category: "led-linijos",
    title: "LED perimetras vonios kambario lubose",
    location: "Privatus namas",
    image_url: "/gallery/led-vonia-kampas.jpg",
  },
  {
    id: 29,
    category: "led-linijos",
    title: "Simetriškos LED linijos koridoriuje",
    location: "Privatus namas",
    image_url: "/gallery/led-koridorius-3.jpg",
  },
  {
    id: 30,
    category: "led-linijos",
    title: "U formos LED linija prieškambario lubose",
    location: "Privatus namas",
    image_url: "/gallery/led-raide-u.jpg",
  },
  {
    id: 31,
    category: "led-linijos",
    title: "LED perimetras ir taškiniai šviestuvai svetainėje",
    location: "Butas",
    image_url: "/gallery/led-svetaine-2.jpg",
  },
  {
    id: 32,
    category: "matines",
    title: "Matinės lubos su juoda šviestuvų apdaila",
    location: "Privatus namas",
    image_url: "/gallery/matines-kampas.jpg",
  },
  {
    id: 33,
    category: "procesas",
    title: "Elektros instaliacija baigtose matinėse lubose",
    location: "Butas",
    image_url: "/gallery/procesas-instaliacija.jpg",
  },
  {
    id: 34,
    category: "matines",
    title: "Matinės lubos su taškiniais šviestuvais miegamajame",
    location: "Butas",
    image_url: "/gallery/matines-spinta.jpg",
  },
  {
    id: 35,
    category: "led-linijos",
    title: "Zigzago LED linijos ilgame koridoriuje",
    location: "Butas",
    image_url: "/gallery/led-zigzagas-koridoriuje.jpg",
  },
  {
    id: 36,
    category: "led-linijos",
    title: "Kampinė LED linija sanmazgyje",
    location: "Butas",
    image_url: "/gallery/led-sanmazgas.jpg",
  },
  {
    id: 37,
    category: "led-linijos",
    title: "Geometriniai LED stačiakampiai erdvioje svetainėje",
    location: "Privatus namas",
    image_url: "/gallery/led-staciakampiai.jpg",
  },
  {
    id: 38,
    category: "led-linijos",
    title: "Kvadratinė LED linija prieškambaryje",
    location: "Butas",
    image_url: "/gallery/led-kvadratas.jpg",
  },
  {
    id: 39,
    category: "led-linijos",
    title: "LED kontūras virš lango zonos",
    location: "Butas",
    image_url: "/gallery/led-langas.jpg",
  },
  {
    id: 40,
    category: "led-linijos",
    title: "Paslėpta LED juosta virš lango — detalė",
    location: "Butas",
    image_url: "/gallery/led-langas-detale.jpg",
  },
  {
    id: 41,
    category: "matines",
    title: "Matinės lubos su magnetinio profilio bėgeliu",
    location: "Privatus namas",
    image_url: "/gallery/matines-begelis.jpg",
  },
  {
    id: 42,
    category: "blizgios",
    title: "Blizgios lubos su taškiniais šviestuvais vonioje",
    location: "Privatus namas",
    image_url: "/gallery/blizgios-vonia.jpg",
  },
  {
    id: 43,
    category: "matines",
    title: "Matinės lubos su integruotomis ventiliacijos grotelėmis",
    location: "Privatus namas",
    image_url: "/gallery/matines-groteles.jpg",
  },
  {
    id: 44,
    category: "matines",
    title: "Dvigubi juodi profilių bėgeliai prie lango",
    location: "Privatus namas",
    image_url: "/gallery/matines-begeliai.jpg",
  },
  {
    id: 45,
    category: "matines",
    title: "Matinės lubos su juodu bėgeliu ir ventiliacija",
    location: "Privatus namas",
    image_url: "/gallery/matines-kampas-langas.jpg",
  },
  {
    id: 46,
    category: "procesas",
    title: "Įleisti linijiniai profiliai prieš apšvietimo pajungimą",
    location: "Privatus namas",
    image_url: "/gallery/procesas-profiliai.jpg",
  },
];

export const GALLERY_FILTERS = [
  { id: "visi", label: "Visi darbai" },
  { id: "led-linijos", label: "LED linijos" },
  { id: "matines", label: "Matinės" },
  { id: "blizgios", label: "Blizgios" },
  { id: "procesas", label: "Darbų procesas" },
];

export const MARQUEE_ITEMS = [
  "Montavimas per 1 dieną",
  "10 metų garantija",
  "7 metų patirtis",
  "Šimtai patenkintų klientų",
  "Švarus darbas be dulkių",
  "Saugi technologija",
  "Vilnius",
  "Kaunas",
  "Klaipėda",
  "Šiauliai",
  "Panevėžys",
  "Visa Lietuva",
];

export const CITIES = ["Vilnius", "Kaunas", "Klaipėda", "Šiauliai", "Panevėžys", "Kitas miestas"];

export const FAQ_ITEMS = [
  {
    q: "Ar tikrai lubos sumontuojamos per vieną dieną?",
    a: "Taip. Standartinė patalpa (15–40 m²) užtrunka 3–5 valandas. Sudėtingesni projektai su LED linijomis ar keliais lygiais gali užtrukti iki vakaro, bet visada baigiame tą pačią dieną.",
  },
  {
    q: "Ką apima 10 metų garantija?",
    a: "Garantija galioja tiek medžiagoms (plėvelei, audiniui), tiek montavimo darbams: siūlėms, profiliams ir įtempimui. Garantinis talonas išduodamas kartu su sąskaita.",
  },
  {
    q: "Ar montuojant bus dulkių ir purvo?",
    a: "Ne. Gręždami naudojame pramoninius siurblius su filtracija. Po darbų patalpą paliekame švarią — tereikia mėgautis rezultatu.",
  },
  {
    q: "Kiek kainuoja įtempiamos lubos?",
    a: "Kaina priklauso nuo lubų tipo, ploto, šviestuvų skaičiaus ir patalpos geometrijos. Tikslią sąmatą sudarome po nemokamo matavimo — ji galutinė ir nesikeičia.",
  },
  {
    q: "Ar atvažiuojate į kitus miestus?",
    a: "Taip, dirbame visoje Lietuvoje — Vilniuje, Kaune, Klaipėdoje, Šiauliuose, Panevėžyje ir kitur. Išvykimas į matavimą nemokamas nepriklausomai nuo atstumo.",
  },
];
